import { FIELDS, RANGE_SELECTOR_MODELS } from '../../shared/screener-constants';

// Most range selectors utilize the same descriptors,
// so make them reusable.
const defaultDescriptors = [
  { style: '', value: 'Lowest' },
  { style: 'text-center', value: 'Average' },
  { style: 'text-right', value: 'Highest' }
];

const rangeSelectors = () => {
  return {
    [RANGE_SELECTOR_MODELS.PERFORMANCE]: {
      heading: 'Performance',
      selectors: [false, false, false, false, false],
      srText: [
        'Lowest Performance',
        'Below Average Performance',
        'Average Performance',
        'Above Average Performance',
        'Highest Performance'
      ],
      descriptors: defaultDescriptors,
      fieldKey: FIELDS.PERFORMANCEFILTER,
      glossaryLink: 'Performance'
    },

    [RANGE_SELECTOR_MODELS.RISK]: {
      heading: 'Risk',
      selectors: [false, false, false, false, false],
      srText: [
        'Lowest Risk Level',
        'Below Average Risk Level',
        'Average Risk Level',
        'Above Average Risk Level',
        'Highest Risk Level'
      ],
      descriptors: defaultDescriptors,
      fieldKey: FIELDS.RISKFILTER,
      glossaryLink: 'Risk Measures'
    },

    [RANGE_SELECTOR_MODELS.EXPENSE]: {
      heading: 'Expense',
      selectors: [false, false, false, false, false],
      srText: [
        'Lowest Net Expense',
        'Below Average Net Expense',
        'Average Net Expense',
        'Above Average Net Expense',
        'Highest Net Expense'
      ],
      descriptors: defaultDescriptors,
      fieldKey: FIELDS.EXPENSEFILTER,
      glossaryLink: 'Gross / Net Expense Ratio'
    },

    [RANGE_SELECTOR_MODELS.PERF_VS_PEERS]: {
      heading: 'Performance vs peers',
      selectors: [false, false, false, false, false],
      srText: [
        'Lowest Performance vs peers',
        'Below Average Performance vs peers',
        'Average Performance vs peers',
        'Above Average Performance vs peers',
        'Highest Performance vs peers'
      ],
      descriptors: defaultDescriptors,
      fieldKey: FIELDS.PERFVSPEERSFILTER,
      glossaryLink: 'Performance vs Peers'
    },

    [RANGE_SELECTOR_MODELS.YIELD]: {
      heading: 'Yield',
      selectors: [false, false, false, false, false],
      srText: [
        'Lowest Yield',
        'Below Average Yield',
        'Average Yield',
        'Above Average Yield',
        'Highest Yield'
      ],
      descriptors: defaultDescriptors,
      fieldKey: FIELDS.YIELDFILTER,
      glossaryLink: 'Yield'
    },

    [RANGE_SELECTOR_MODELS.DAILY_YTD_RETURN]: {
      heading: 'Daily YTD return',
      selectors: [false, false, false, false, false],
      srText: [
        'Lowest Daily Year to Date Return',
        'Below Average Daily Year to Date Return',
        'Average Daily Year to Date Return',
        'Above Average Daily Year to Date Return',
        'Highest Daily Year to Date Return'
      ],
      descriptors: defaultDescriptors,
      fieldKey: FIELDS.DAILYYTDFILTER,
      glossaryLink: 'Daily YTD return'
    },

    [RANGE_SELECTOR_MODELS.RISK_VS_PEERS]: {
      heading: 'Risk level vs peers',
      selectors: [false, false, false, false, false],
      srText: [
        'Lowest Risk level vs peers',
        'Below Average Risk level vs peers',
        'Average Risk level vs peers',
        'Above Average Risk level vs peers',
        'Highest Risk level vs peers'
      ],
      descriptors: defaultDescriptors,
      fieldKey: FIELDS.RISKVSPEERS,
      glossaryLink: 'Risk vs peers'
    },

    [RANGE_SELECTOR_MODELS.INCEPTION_DATE]: {
      heading: 'Inception date',
      selectors: [false, false, false, false],
      srText: [
        'Pre-2000 Inception Date',
        '2000s Inception Date',
        '2010s Inception Date',
        'Post-2019 Inception Date'
      ],
      descriptors: [
        { style: '', value: 'Pre-2000' },
        { style: 'text-center', value: '2000s' },
        { style: 'text-center', value: '2010s' },
        { style: 'text-right', value: 'Post-2019' }
      ],
      fieldKey: FIELDS.TCINCEPTIONDATE,
      glossaryLink: 'Inception Date'
    }
  };
};

export default rangeSelectors;
